export const SHOOTSTA_PREFIX_ROLES = [
'SHOOTSTA_EDITOR',
'SHOOTSTA_SENIOR_EDITOR',
'SHOOTSTA_ADMIN',
'SHOOTSTA_AM',
'SHOOTSTA_TECH_SUPPORT',
'SHOOTSTA_BDM'];


export default ((orgMembership) => {
  if (!orgMembership || !orgMembership.role) {
    return false;
  }

  return SHOOTSTA_PREFIX_ROLES.includes(orgMembership.role.name) &&
  orgMembership.status === 'ACCEPTED';
});